$(function () {
  //
  let hoverNavId = "";
  //
  $(".home-header-banner-wrap .nav-wrap .nav-item").hover(
    function () {
      hoverNavId = $(this).attr("data-id");
      toggerSubNav();
    },
    function () {
      hoverNavId = "";
      toggerSubNav();
    }
  );
  //
  $(".sub-nav-group-wrap").hover(
    function () {
      clearTimeout(timeout);
    },
    function () {
      hoverNavId = "";
      toggerSubNav();
    }
  );
  //
  let timeout = null;
  const toggerSubNav = () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      hideSubNav();
      if (hoverNavId) {
        const $links = $(
          `.sub-nav-group-item[data-id="${hoverNavId}"] a.sub-nav-item`
        );
        if ($links.length > 0) {
          $(
            `.sub-nav-group-wrap, .sub-nav-group-item[data-id="${hoverNavId}"]`
          ).removeClass("hide");
        }
      }
    }, 100);
  };
  const hideSubNav = () => {
    $(".home-header-banner-wrap")
      .find(".sub-nav-group-wrap,.sub-nav-group-item")
      .addClass("hide");
  };
});

//banner图片轮播
$(function () {
  const $imgs = $(".cjmy-header .img-swiper-item");
  if ($imgs.length > 1) {
    const $pagination = $('<div class="pagination-wrap"></div>');
    for (let i = 0; i < $imgs.length; i++) {
      $pagination.append(
        '<div class="pagination-item"><i class="white-box"></i></div>'
      );
    }
    $(".cjmy-header .img-swiper-list").after($pagination);
  }
  //
  const $paginations = $(".cjmy-header .pagination-wrap .pagination-item");
  //
  let activeIndex = 0;
  const activeSync = () => {
    if (!$imgs.get(activeIndex)) {
      activeIndex = 0;
    }
    $imgs.removeClass("active").eq(activeIndex).addClass("active");
    $paginations.removeClass("active").eq(activeIndex).addClass("active");
  };
  setTimeout(activeSync, 100);
  $paginations.on("click", function () {
    activeIndex = $paginations.index($(this));
    activeSync();
    restartInterval();
  });
  let interval = null;
  const restartInterval = () => {
    clearInterval(interval);
    interval = setInterval(() => {
      activeIndex++;
      activeSync();
    }, 5000);
  };
  restartInterval();
});

$(function () {
  // 初始化   默认匹配hash值,  如果没有展示第一项
  const hash = location.hash.split("#")[1];
  // const pathname = location.pathname;
  // let hash = "";
  // if (pathname.includes("antifake")) {
  //   hash = 1;
  // } else if (pathname.includes("trace")) {
  //   hash = 2;
  // } else if (pathname.includes("logistics")) {
  //   hash = 3;
  // } else if (pathname.includes("marketing")) {
  //   hash = 4;
  // } else if (pathname.includes("warranty")) {
  //   hash = 5;
  // } else if (pathname.includes("line")) {
  //   hash = 6;
  // }
  $(".about-content-nav li")
    .eq(hash - 1)
    .find(".content-nav-icon")
    .addClass("content-nav-icon-active");
  $(".about-content-nav li")
    .eq(hash - 1)
    .find(".content-nav-line")
    .addClass("line-hover");
  $($(".about-main")[hash - 1]).show();
  /********菜单导航栏切换***********/
  $(".about-content-nav").on("click", "li", function () {
    $(".about-content-nav li .content-nav-line").removeClass("line-hover");
    $(".about-content-nav li .content-nav-icon").removeClass(
      "content-nav-icon-active"
    );
    $(this).children(".content-nav-line").addClass("line-hover");
    $(this).children(".content-nav-icon").addClass("content-nav-icon-active");
    $(".about-main").hide();
    var num = $(".about-content-nav li").index(this) + 1;
    location.hash = num; //切换保存hash值
    // var scrollHeight;
    // scrollHeight = 400;
    // $("html,body").animate({ scrollTop: scrollHeight }, 400);
    $($(".about-main")[num - 1]).show();
  });
});
